import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserModule } from './component/user/user.module';
import { AppInfoModule } from './component/app-info/app-info.module';

@NgModule({
  imports: [CommonModule, UserModule, AppInfoModule],
  exports: [UserModule, AppInfoModule],
})
export class CoreModule {}
